'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var index = require('./portals/customer/index.js');
var index$1 = require('./portals/agent/index.js');
var index$2 = require('./portals/returns/index.js');
var ClaimReasonField = require('./common/views/OrderLookup/fields/ClaimReasonField.js');



exports.CustomerPortal = index["default"];
exports.AgentPortal = index$1.ClaimsWithAgentRoot;
exports.ReturnsClaimsProvider = index$2.ReturnsClaimsProvidersWithApollo;
exports.ClaimReasonField = ClaimReasonField["default"];
